import {
  TASK_ASSIGNED_TO, TASK_DESCRIPTION, TASK_DURATION, TASK_END_DATE, TASK_NAME,
  TASK_PRIORITY, TASK_RELATE_TO, TASK_START_DATE,
} from 'constants/formFields';
import {
  DEFAULT_OPTION_MA, DEFAULT_OPTION_VC, TASK_TYPE, TASK_TYPE_ACTION,
} from 'constants/general';
import { TASK_PRIORITY_OPTIONS } from 'constants/taskPriority';

import type ISingleTask from 'store/slices/tasksManagement/interfaces/ISingleTask';

interface IGetTaskManagementDefaultValues {
  itemData?: ISingleTask,
  typeModal?: typeof TASK_TYPE_ACTION[keyof typeof TASK_TYPE_ACTION],
}

function getTaskManagementDefaultValues({ itemData, typeModal }: IGetTaskManagementDefaultValues) {
  const defaultOption = { value: '', label: '' };
  const defaultOptionRelateTo = itemData?.type === TASK_TYPE.VCM ? DEFAULT_OPTION_VC : DEFAULT_OPTION_MA;
  const labelRelateTo = typeModal === TASK_TYPE_ACTION.EDIT ? defaultOptionRelateTo : defaultOption;

  const {
    title,
    description,
    startDate,
    endDate,
    duration,
    priority,
    valueChainMap,
    materialityAssessment,
    type,
    assignedUsers,
  } = itemData || {};

  const currentPriority = TASK_PRIORITY_OPTIONS.find((option) => option.value === priority);
  const titleRelatedTo = type === TASK_TYPE.VCM ? TASK_TYPE.VALUE_CHAIN : TASK_TYPE.MATERIALITY_ASSESSMENT;

  return {
    [TASK_NAME]: title || '',
    [TASK_RELATE_TO]: valueChainMap || materialityAssessment ? {
      value: valueChainMap?.id.toString() || materialityAssessment?.id.toString(),
      label: `${titleRelatedTo} - ${valueChainMap?.name || materialityAssessment?.name}`,
    } : labelRelateTo,
    [TASK_ASSIGNED_TO]: assignedUsers?.map((user) => ({
      value: user?.id.toString(),
      label: `${user?.firstName} ${user?.lastName}`,
    })) || [],
    [TASK_DESCRIPTION]: description || '',
    [TASK_START_DATE]: startDate || '',
    [TASK_END_DATE]: endDate || '',
    [TASK_DURATION]: duration ? duration.toString() : '',
    [TASK_PRIORITY]: currentPriority || defaultOption,
  };
}

export default getTaskManagementDefaultValues;
